module.exports = __webpack_public_path__ + "static/img/6.ca925a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/6.png
// module id = KhUr
// module chunks = 0